@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: flex;
  gap: 20px;
  width: 100%;
}

.card {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--border-soft);
  @include border-radius-r2;
  overflow: hidden;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items:flex-start;
  padding: 16px 12px 0;
}

.countryInfo {
  display: flex;
  gap: 8px;
}

.flag {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.countryName {
  @include typography-v2-body-base;
}

.description {
  @include typography-v2-body-xs;
  padding: 16px 12px;
}
